<template>
  <b-modal size="lg" v-model="is_show" :title="modalTitle" hide-footer @hide="onHide">
    <b-form @submit.prevent="onSubmit" @reset="onHide" v-loading="loading.detail">
      <b-form-group label="Name">
        <b-input
          v-model="form.name"
          placeholder="Input content name"
          type="text"/>
      </b-form-group>
      <b-form-group label="Items">
        <el-select multiple class="mb-2" v-model="form.items" @change="handleItems" placeholder="Select or search items" style="width: 100%" filterable>
          <el-option
            v-for="item in list_items"
            :key="item._id"
            :label="item.name"
            :value="item._id">
          </el-option>
        </el-select>
      </b-form-group>
      <b-form-group label="Categories">
        <el-select multiple class="mb-2" v-model="form.categories" @change="handleCategories" placeholder="Select or search category" style="width: 100%" filterable>
          <el-option
            v-for="item in list_categories"
            :key="item._id"
            :label="item.name"
            :value="item._id">
          </el-option>
        </el-select>
      </b-form-group>
      <b-form-group label="Is Private">
        <el-select
          class="w-full"
          v-model="form.is_private"
          @change="handlerChangeSegment"
          placeholder="Select">
          <el-option v-for="(item, index) in private_options" :value="item.value" :key="index" :label="item.label"/>
        </el-select>
      </b-form-group>
      <b-form-group label="Company" v-if="form.is_private === true">
        <el-select multiple class="mb-2" :loading="loading.company" v-model="form.company_ids" @change="handleCompanyChange" placeholder="Select or search company" style="width: 100%" filterable remote :remote-method="searchCompany">
          <el-option
            v-for="item in companies.rows"
            :key="item.company_id"
            :label="item.company_name"
            :value="item.company_id">
          </el-option>
        </el-select>
      </b-form-group>
      <b-form-group label="Choose Users" v-if="form.is_private=== true">
        <el-button @click="handlerChooseRecipient" size="small">Select Users</el-button>
      </b-form-group> 
        <p v-if="form.is_private=== true">Total Users: {{ temp_selected.length || form.user_ids.length }}</p>
        <!-- <p>Total ids: {{ temp_selected }}</p> -->
      <!-- <b-form-group label="index">
        <b-input
          v-model="form.index"
          placeholder="Input content index"
          type="text"/>
      </b-form-group> -->
      <b-form-group label="Description">
        <b-textarea
          v-model="form.description"
          placeholder="Input content description"/>
      </b-form-group>
      <b-form-group label="Status">
        <el-select v-model="form.status" class="w-full" size="medium" placeholder="Select status">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </b-form-group>
      <div class="d-flex flex-row float-right">
        <el-button @click="onSubmit" :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit</el-button>
        <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
      </div>
      <b-modal size="xl" v-model="showModalRecipientTable" title="Choose users" hide-footer @hide="onHideApp" body-class="p-0">
        <div class="card">
          <div class="card-header justify-content-between">
            <div class="card-title">
              App User
            </div>
            <div class="flex flex-row mb-2 pr-2 float-right">
              <b-input style="width: 200px" size="sm" type="text" v-model="user_filter.search_keyword" placeholder="Input search keyword" class="mr-2"/>
              <el-select size="small" v-model="user_filter.search_by" class="mr-2" style="width: 150px">
                <el-option v-for="(item, index) in user_filter.search_options" :key="index" :value="item.value" :label="item.text"/>
              </el-select>
              <el-button type="primary" @click="searchHandler" size="small"><font-awesome-icon icon="search"/> Search</el-button>
            </div>
          </div>
          <div class="table-responsive">
            <el-table :data="list_app" v-model="form.user_ids"
              ref="list_table"
              @selection-change="handlerSelectionChange"
              class="table card-table text-nowrap table-vcenter"
              style="width: 100%">
              <el-table-column type="selection" width="65"/>
              <el-table-column width="200" prop="full_name" label="Name" :sortable="true"/>
              <el-table-column width="200" prop="company_name" label="Company"></el-table-column>
              <el-table-column min-width="250" prop="email" label="Email"></el-table-column>
              <el-table-column width="150" prop="phone_number" label="Phone Number"></el-table-column>
              <el-table-column width="150" prop="created_at_str" label="Join Date"></el-table-column>
              <el-table-column width="150" prop="login_at_str" label="Last Login Date"></el-table-column>
              <el-table-column width="120" prop="private_status" label="Account Type">
                <template slot-scope="item">
                  <span class="tag" :class="item.row.private_status_color">{{ item.row.private_status }}</span>
                </template>
              </el-table-column>
              <el-table-column width="150" prop="private_status" label="KYC Status">
                <template slot-scope="item">
                  <span class="tag" :class="item.row.kyc_status_color">{{ item.row.kyc_status_str }}</span>
                </template>
              </el-table-column>
              <el-table-column width="150" prop="status" label="Status">
                <template slot-scope="item">
                  <span class="tag" :class="item.row.status_color">{{ item.row.status_str }}</span>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-empty description="No data found" :image="emptyStateImage"></el-empty>
              </template>
            </el-table>
          </div>
          <div class="d-flex justify-content-between p-2">
            <small>Showing {{ showingFromApp }} to {{ showingUntilApp }} of {{ total_rows }} entries</small>
            <div class="inline-table">
              <b-pagination
                class="table-cell"
                @change="pageChangeHandlerApp"
                :per-page="per_page"
                :limit="5"
                :total-rows="total_rows"
                v-model="page"
              />
            </div>
          </div>
        </div>
        <br>
        <div class="d-flex justify-content-between p-2">
        <div class="inline-table">
        </div>
        </div>
        <br>
        <div class="float-right p-2">
          <el-button @click="onSubmitApp" :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit App</el-button>
          <el-button @click="onHideApp" size="small" class="mr-2 ml-2">Cancel</el-button>
          <br>
          {{ temp_selected }}
        </div>
      </b-modal>
    </b-form>
  </b-modal>
</template>
<script>
import {
  GET_PARENTSECTION, ADD_MENU_CONTENT, UPDATE_MENU_CONTENT, DETAIL_MENU_CONTENT, GET_SUB_CATEGORIES, GET_ITEMS
} from '@/store/modules/app_content';
import popupErrorMessages from '@/library/popup-error-messages';
import ModalContentRecipient from './ModalContentRecipient.vue';
import emptyStateImage from '@/assets/images/empty-state.png';
import { GET_COMPANIES } from '@/store/modules/companies';
import { GET_APPUSERS } from '@/store/modules/app_user';
export default {
  name: 'ModalSectionMenuContent',
  components: {
    ModalContentRecipient,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'add',
    },
    selectedContent: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      list: [],
      list_items: [],
      list_categories: [],
      total_row: 0,
      total_rows: 0,
      total_rows_app: 0,
      emptyStateImage,
      showModalRecipientTable: false,
      is_show: false,
      showModalRecipient: false,
      loading: {
        submit: false,
        detail: false,
      },
      apply_to_user: false,
      form: {
          name: "",
          description: "",
          items: [],
          categories: [],
          is_private: false, 
          company_ids: '', 
          user_ids: [],
          index: 1,
          status: false,
          // target_user: []
      },
      selected_file: null,
      parent_section: [],
      statusOptions: [
          {
            value: true,
            label: 'Active',
          }, 
          {
            value: false,
            label: 'Inactive',
          },
        ],
      companies: {
        rows: [],
        count: 0,
      },
      content_id: null,
      search_keyword: 'full_name',
      search: '',
      temp_checked: {},
      checked: {},
      user_filter: {
        search_by: 'full_name',
        search_keyword: '',
        search_options: [
          { value: 'full_name', text: 'Full Name' },
          { value: 'email', text: 'Email' },
          { value: 'phone_number', text: 'Phone Number' },
        ],
      },
      temp_selected: [],
      per_page: 10,
      app_users: {
        rows: [],
        count: 0,
      },
      page: 1,
      list_app: [],
      user_typeOptions: [
        {
          value: 'all',
          label: 'All',
        },
        {
          value: 'private',
          label: 'Private',
        },
      ],
      private_options: [
         {
          value: true,
          label: 'True',
        },
        {
          value: false,
          label: 'False',
        },
      ]
    };
  },
  computed: {
    modalTitle() {
      return this.type === 'add' ? 'Add Menu Content' : 'Update Menu Content';
    },
    showingFromApp() {
      return this.total_rows ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntilApp() {
      if (this.total_rows) {
        if (this.list_app.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
  },

  methods: {
    async getListCategories() {
      this.loading.table = true;
      await this.$store.dispatch(GET_SUB_CATEGORIES, {
        page: this.page,
        per_page: this.per_page,
      }).catch((err) => {
        popupErrorMessages(err);
      });
      this.loading.table = false;
      const response = this.$store.getters.content_categories;
      this.list_categories = response.rows;
      this.total_row = response.count;
    },
    async getListItems() {
      this.loading.table = true;
      await this.$store.dispatch(GET_ITEMS, {
        page: this.page,
        per_page: this.per_page,
      }).catch((err) => {
        popupErrorMessages(err);
      });
      this.loading.table = false;
      const response = this.$store.getters.items;
      this.list_items = response.rows;
      this.total_row = response.count;
    },
    handlerChangeSegment(value) {
      if (value === true) {
        this.form.company_ids = [];
        this.loadCompanies();
        this.getListCategories();
      }
    },
    async onSubmit() {
      this.loading.submit = true;
      this.form.user_ids = this.temp_selected;
      if (this.type === 'edit') {
        await this.updateContent();
      } else {
        await this.$store.dispatch(ADD_MENU_CONTENT, this.form)
          .then(() => {
            this.$message({
              title: 'Success',
              type: 'success',
              message: 'Content successfully created',
            });
            this.$emit('afterSubmit');
          }).catch((err) => {
            popupErrorMessages(err.response.data);
          });
      }
      this.loading.submit = false;
    },
    async updateContent() {
      await this.$store.dispatch(UPDATE_MENU_CONTENT, {
        _id: this.content_id,
        data: this.form,
      }).then(() => {
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Content successfully updated',
        });
        this.$emit('afterSubmit');
      }).catch((err) => {
        popupErrorMessages(err.response.data);
      });
    },
    async pageChangeHandlerApp(page) {
      this.checked[`page${this.page}`] = this.temp_checked[`page${this.page}`] || [];
      this.page = page;
      await this.getListApp();
      if (this.checked[`page${this.page}`]) {
        this.checked[`page${this.page}`].forEach((v) => {
          const obj = this.list_app.find((k) => k.owned_by === v.owned_by);
          if (obj) {
            setTimeout(() => {
              this.$refs.list_table.toggleRowSelection(obj);
            }, 100);
          }
        });
      }
    },
    onSubmitApp() {
      this.selectedRecipients = [...this.temp_selected];
      this.showModalRecipientTable = false;
    },
    onHideApp() {
      this.showModalRecipientTable = false
    },
    handlerSelectionChange(val) {
      const existingIds = new Set(this.temp_selected.map(item => item.owned_by));
      val.forEach(item => {
        if (!existingIds.has(item.owned_by)) {
          this.temp_selected.push(item.owned_by);
        }
      });
    },
    searchHandler() {
      this.page = 1;
      this.search_by = this.user_filter.search_by;
      this.search_keyword = this.user_filter.search_keyword;
      this.getListApp();
    },
    searchHandlerBanner() {
      this.page = 1;
      this.search = this.search;
      this.getList();
    },
    onHide() {
      this.form = {
        name: '',
        description: '',
        items: [],
        categories: [],
        is_private: false, 
        company_ids: '',
        user_ids: [],
        index: 1,
        status: false,
      };
      this.temp_selected = [],
      this.apply_to_user = false;
      this.$emit('onHide');
    },
    handlerChooseRecipient() {
      this.showModalRecipientTable = true;
    },
    async getParentSection() {
      await this.$store.dispatch(GET_PARENTSECTION, {
        type: 'home',
      }).then(({ rows }) => {
        this.parent_section = rows;
      });
    },
    handlerBtnChooseUser() {
      this.showModalRecipient = true;
    },
    onSubmitRecipient(data) {
      // this.form.target_user = data.map((v) => v.owned_by);
      this.showModalRecipient = false;
    },
    async getDetail(_id) {
      this.loading.detail = true;
      await this.$store.dispatch(DETAIL_MENU_CONTENT, { _id })
      .then((res) => {
        const content = res?.rows;
        this.content_id = content?._id;
        this.form = {
          name: content?.name,
          index: content.index,
          status: content.status,
          description: content.description,
          categories: content.categories,
          company_ids: content.company_ids,
          is_private: content.is_private,
          items: content.items,
          user_ids: content.user_ids,
        };
      })
      .catch((err) => {
      });
        this.loading.detail = false;
    },
    searchCompany(value) {
      clearTimeout(this.timeoutSearchCompany);
      this.timeoutSearchCompany = setTimeout(() => {
        this.loadCompanies({
          search_keyword: value,
        });
      }, 1000);
    },
    async handleCompanyChange() {
      await this.getListApp();
    },
    async handleCategories() {
      await this.getListCategories();
    },
    async handleItems() {
      await this.getListItems();
    },
    async loadCompanies({ search_keyword = '' } = {}) {
      this.loading.company = true;
      await this.$store.dispatch(GET_COMPANIES, {
        search_keyword,
      });
      this.loading.company = false;
      this.companies = this.$store.getters.companies;
    },
    async mounted() {
      await this.loadCompanies();
      await this.getListApp();
      await this.getListCategories();
    },
    async getListApp() {
      this.loading.table = true;
      await this.$store.dispatch(GET_APPUSERS, {
        page: this.page,
        per_page: 10,
        company_id: this.form.company_ids,
        order_by: "full_name:asc"
      }).catch(() => {});
      const { rows, count } = this.$store.getters.app_users;
      this.total_rows = count || 0;
      this.list_app = rows;
      this.loading.table = false;
    },
  },
  watch: {
    show() {
      this.is_show = this.show;
      if (this.show) {
        if (this.type === 'edit') {
          this.getDetail(this.selectedContent._id);
          this.loadCompanies(),
          this.getListApp()
        }
      }
      this.getListCategories()
      this.getListItems()
    },
  },
};
</script>